import script from "./bjNumberCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./bjNumberCard.vue?vue&type=script&setup=true&lang=ts"

import "./bjNumberCard.vue?vue&type=style&index=0&id=df0554b4&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0554b4"]])

export default __exports__